import { render, staticRenderFns } from "./ConnectedTravels.vue?vue&type=template&id=0774881f&"
import script from "./ConnectedTravels.vue?vue&type=script&lang=js&"
export * from "./ConnectedTravels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports